import { HvlDateConverter, HvlMapConverter } from '@hvlng/framework-bff/util';
import { JsonProperty, JsonObject } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { EnumProcessActionType, EnumProcessActionTypeConverter } from './enum-process-action-type';

@JsonObject('ProcessModel')
export class ProcessModel {
    @EmptyControl()
    @JsonProperty('taskId', String, true)
    taskId: string = null;

    @EmptyControl()
    @JsonProperty('processInstanceId', String, true)
    processInstanceId: string = null;

    @EmptyControl()
    @JsonProperty('comment', String, true)
    comment: string = null;

    @JsonProperty('processActionType', EnumProcessActionTypeConverter, true)
    processActionType: EnumProcessActionType = null;

    @EmptyControl()
    @JsonProperty('sourceScreen', String, true)
    sourceScreen: string = null;

    @EmptyControl()
    @JsonProperty('key', String, true)
    key: string = null;

    @EmptyControl()
    @JsonProperty('businessKey', String, true)
    businessKey: string = null;

    @EmptyControl()
    @JsonProperty('startTime', HvlDateConverter, true)
    startTime: Date = null;

    @EmptyControl()
    @JsonProperty('executionId', String, true)
    executionId: string = null;

    @JsonProperty('processVariables', HvlMapConverter, true)
    processVariables: Map<string, any> = new Map<string, any>();
}
